<div class="flex flex-col gap-5">
  <app-panel titleKey="project.steps.rfq.contractParameters">
    <app-contract-parameters
      [isReadOnly]="isReadOnly()"
      [inputObject]="contractParameters()"
      (submitOutput)="handleParametersSubmit($event)"
    />

    <p-divider />

    <app-project-scope
      [isReadOnly]="isReadOnly()"
      [inputObject]="contractParameters()"
      (submitOutput)="handleScopeSubmit($event)"
    />
  </app-panel>

  <app-contract-implementation-timeline
    [isReadOnly]="isReadOnly()"
    [inputObject]="implementationTimelineData()"
    (submitOutput)="handleImplementationTimelineSubmit($event)"
  />
</div>
